import { render } from "./Agendas.vue?vue&type=template&id=747af986&scoped=true"
import script from "./Agendas.vue?vue&type=script&lang=js"
export * from "./Agendas.vue?vue&type=script&lang=js"

import "./Agendas.vue?vue&type=style&index=0&id=747af986&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\fronted_sit_bolivia\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-747af986"]])

export default __exports__